import { Toast } from "@sscs/ui";
import { useCurrentOrganization, useDialog } from "Hooks";
import { apiErrorToast } from "Utils";
import { useDisableSsoMutation } from "../services/sso.api";

type UseLocalLoginConfiguration = {
  onSubmit: () => void;
  isConfirmSaveOpen: boolean;
  openConfirmSaveDialog: () => void;
  closeConfirmSaveDialog: () => void;
  handleDisableSSO: () => void;
  isLoading: boolean;
};

const useLocalLoginConfigForm = (): UseLocalLoginConfiguration => {
  const [disableSso] = useDisableSsoMutation();
  const confirmDisableSSODialog = useDialog();
  const currentOrganization = useCurrentOrganization();

  const handleDisableSSO = async () => {
    try {
      if (currentOrganization) {
        await disableSso({
          orgId: currentOrganization.id,
        }).unwrap();
        Toast.show({
          title: "SSO disabled",
          type: "success",
        });
      }
    } catch (error) {
      apiErrorToast(error, "Could not disable SSO");
    }
  };

  const onSubmit = () => {
    confirmDisableSSODialog.open();
  };

  return {
    onSubmit: onSubmit,
    isConfirmSaveOpen: confirmDisableSSODialog.isOpen,
    openConfirmSaveDialog: confirmDisableSSODialog.open,
    closeConfirmSaveDialog: confirmDisableSSODialog.close,
    handleDisableSSO,
    isLoading: false,
  };
};

export default useLocalLoginConfigForm;
